import { MetaData } from "@/domains/common/layout/metadata"
import { PageContainer } from "@/domains/common/layout/page-container"
import { PageTitle } from "@/domains/common/layout/page-title"
import { CL_PRODUCT_COPY } from "@/domains/manual-cl-page/cl-product-copy"
import { MANAGE_MANUAL_CL_V2_BREADCRUMBS } from "@/domains/thick-v2/breadcrumbs"
import { ManagePositionPageComposite } from "@/domains/thick-v2/components/manage-position"

const title = CL_PRODUCT_COPY.v2.managePositionTitle

const ManualClIncreasePositionPage = () => (
  <PageContainer>
    <MetaData title={title} />
    <PageTitle title={title} items={MANAGE_MANUAL_CL_V2_BREADCRUMBS} />
    <ManagePositionPageComposite activeTab="increase" />
  </PageContainer>
)

export default ManualClIncreasePositionPage
